import Vue from 'vue'

import vbclass from 'vue-body-class'
import router from '../routers'

Vue.use(vbclass, router)
